

import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi';


export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);

  const referral = referralcode || location.pathname.split("/")[2] || "";

  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  const handleClick = async (e) => {
    if (e) e.preventDefault();
    if (!Phone || Phone.length !== 10) {
      return Swal.fire({ icon: "error", title: "Oops...", text: "Please enter correct phone number" });
    }
    setIsloading1(true);
    const respone = await apiRequest('login', "POST", { Phone, referral });
    setIsloading1(false);
    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);
      if (respone?.data?.myToken) {
        Swal.fire({ icon: "success", title: "OTP", text: "Demo OTP: " + respone?.data?.myToken });
      }
    } else {
      Swal.fire({ icon: "error", title: "Oops...", text: respone?.data?.msg || "Login failed" });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode });
      setIsloading1(false);
      if (response?.data?.status === 200) {
        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({ icon: "error", title: "Oops...", text: response?.data?.msg || "Something went wrong!" });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({ icon: "error", title: "Oops...", text: "Error verifying OTP" });
    }
  };

  return (
    <div className="premium-login-container">
      {/* Animated Background Elements */}
      <div className="glow-circle top-left"></div>
      <div className="glow-circle bottom-right"></div>

      <div className="glass-login-card fade-in-up">
        
        {/* GIF and Header Section */}
        <div className="login-visuals">
          {/* <img 
            src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZTM4YmU1YjE5YmRmYjU4YmUzZTJmMjYyNzhlN2FjZTgxZDg4YmI5ZiZlcD12MV9pbnRlcm5hbF9naWZzX3NlYXJjaCZjdD1n/26n6WywFabiEGXnQA/giphy.gif" 
            alt="Gaming Dice" 
            className="gaming-gif floating-anim" 
          /> */}
          <h1 className="brand-title">Welcome<span className="gold-text">Back</span></h1>
        
        </div>

        {/* Form Section */}
        <div className="card-body">
          <form onSubmit={otp ? varifyOtp : handleClick}>
            
            <div className="input-group-wrapper slide-in-right">
              <label className="premium-label">Enter Mobile Number</label>
              <div className="phone-input-group">
                <div className="country-code">+91</div>
                <input
                  type="tel"
                  className="premium-input"
                  placeholder="00000 00000"
                  value={Phone}
                  disabled={otp}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                  required
                />
              </div>
            </div>

            {otp && (
              <div className="input-section-otp slide-in-left">
                <label className="premium-label mt-3">Enter Verification Code</label>
                
                {/* Circle styled OTP Input */}
                <input
                  type="text"
                  className="circle-otp-input pulse-anim"
                  placeholder="• • • • • •"
                  maxLength="6"
                  onChange={(e) => settwofactor_code(e.target.value)}
                  required
                />
                
                <div className="resend-timer-box">
                  {seconds > 0 ? (
                    <span className="timer-text">Resend in <strong>{seconds}s</strong></span>
                  ) : (
                    <span className="resend-link" onClick={handleClick}>🔄 Resend OTP</span>
                  )}
                </div>
              </div>
            )}

            <button type="submit" className="premium-submit-btn hover-glow" disabled={isLoading1}>
              {isLoading1 ? <Spinner animation="border" size="sm" /> : (otp ? "VERIFY & PLAY" : "GET OTP")}
            </button>
          </form>
        </div>

        <div className="terms-footer">
          By logging in, you agree to our <strong className="gold-text1">Terms & Conditions</strong>
        </div>
      </div>
    </div>
  );
}